exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "modal-remove-period .responsiveMobile .modal-dialog{max-height:none;max-width:none}modal-remove-period .modal-dialog{max-height:410px;max-width:520px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/components/modals/modalRemovePeriod/modalRemovePeriod.scss
// module id = 1421
// module chunks = 0